<template lang="pug">
  article.service
    figure.service__cover
      img.service__image(
        :src='"."+service.image'
        :alt='service.title'
      )
    .service__body
      template(
        v-if="service.typographyTitle"
      )
        h3.service__title(
          :class='titleClass'
        )
          span(
            v-for="title in service.typographyTitle"
          ) {{ title }}
            br
      h3.service__title(
        v-else
        :class="titleClass"
      ) {{ service.title }}
      p.service__caption(
        v-if='service.caption'
      ) {{ service.caption }}
      //.service__price(
      //  v-html='formattedPrice'
      //)
      .service__button
        Button(
          type='link'
          :to='serviceUrl'
          :classes="['has-arrow', 'has-area']"
          label="Получить услугу"
        )
</template>

<script>
import { mapGetters } from "vuex";
import Button from "@/components/Button.vue";

export default {
  props: {
    id: [Number, String]
  },
  computed: {
    ...mapGetters({
      serviceItem: "services/item"
    }),
    service() {
      return this.serviceItem(this.id);
    },
    formattedPrice() {
      return this.service.price
        ? `<b>от</b>${this.service.price}<i>₽</i>`
        : "<span>Бесплатно</span>";
    },
    serviceUrl() {
      return `/service/${this.id}`;
    },
    titleClass() {
      if (Array.isArray(this.service.title)) {
        return "service__title--small";
      }
      let words = this.service.title.split(" ");
      let className = "";
      if (words.length > 6) {
        className = "service__title--small";
      }
      return className;
    }
  },
  components: {
    Button
  }
};
</script>

<style lang="scss">
.service {
  display: flex;
  flex-direction: column;
  flex: 1;
  position: relative;
  z-index: 0;
  background-color: $white;
  box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.15);
  border-radius: 14px;
  transition: ease transform 300ms;

  &:hover {
    transform: translateY(-10px);
  }

  &__cover {
    transform: translate(-50%, -20px);
    position: absolute;
    top: 0;
    left: 50%;
    z-index: 10;
    width: auto;
    flex-shrink: 0;
  }

  &__image {
    display: block;
    width: 100px;
    height: 80px;
    object-fit: cover;
    border-radius: 25px;
    box-shadow: 0px 15px 20px rgba(0, 0, 0, 0.15);
  }

  &__body {
    display: flex;
    flex-direction: column;
    padding: 70px 20px 20px;
    background-color: rgba(255, 255, 255, 0.9);
    text-align: center;
    justify-content: center;
    border-radius: 14px;
  }

  &__title {
    color: $accent;
    font-weight: $semibold;
    line-height: 1.2;
    font-size: 18px;
    height: 42px;
    &--small {
      font-size: 16px;
      line-height: 1.1;
    }
  }

  &__caption {
    display: none;
    flex-grow: 1;
    margin-top: 10px;
    color: $grey;
    font-weight: $regular;
    line-height: 1.18;
  }

  &__price {
    margin-top: 10px;
    color: $second;
    font-weight: $semibold;
    font-size: 34px;
    line-height: 1.2;

    b {
      margin-right: 5px;
      color: $grey;
      font-weight: $regular;
      font-size: 16px;
    }

    i {
      margin-left: 5px;
      font-style: normal;
      font-weight: $regular;
      font-size: 24px;
    }
  }

  &__button {
    margin-top: 10px;
  }
}
</style>
